<div class="navigation-items">
  <div [matMenuTriggerFor]="profileMenu" class="clickable header-content">
    @if (profile?.photo) {
    <img [src]="'data:image/jpeg;base64,' + profile.photo" alt="User profile" class="thumbnail">
    }
    @else {
    <div class="no-image"></div>
    }
    <span class="header-content__title">Welcome, {{ userFullName }}</span>
  </div>

  <mat-menu #profileMenu="matMenu" class="header-profile-menu">
    <div class="header-popper">
      <div fxLayout="row" fxLayoutGap="10px">
        <div fxLayoutAlign="center center" class="header-popper-img">
          @if (profile?.photo) {
            <img [src]="'data:image/jpeg;base64,' + profile.photo" alt="User profile">
            }
            @else {
            <div class="no-image"></div>
            }
        </div>
        <div class="header-popper-content">
          <span class="header">{{ profile?.displayName }}</span>
          <span>{{ profile?.jobTitle }}</span>
          <span class="mail">{{ profile?.mail }}</span>
          <span *ngIf="profile?.mobilePhone">{{ profile?.mobilePhone }}</span>
        </div>
      </div>
    </div>
  </mat-menu>
</div>
